class ClassContact {

    constructor() {
        this.getObjects = this.getObjects();
    }

    getObjects = () => {
        return {
            name: '',
            email: '',
            phone: '',
            subject: '',
            bestTime: '',
            message: '',
            acceptPolicy: false,
        }
    }
}

export default ClassContact;